import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '@/lib/fetcher';

async function postRaw(ctx, url, data) {
  const originPath = window.location.pathname;
  const loggedIn = JSON.parse(localStorage.getItem('logged_in_qram') || '{}');
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': loggedIn?.token,
    'X-Origin-Path': originPath,
  };

  try {
    const response = await axios({
      method: 'post',
      url: process.env.VUE_APP_API_BASE_URL + url,
      headers,
      data,
    });

    if (response?.data?.code === 401) {
      ctx.dispatch('logout', null, { root: true });
    }

    return response.data;
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.data?.code === 401) {
      ctx.dispatch('logout', null, { root: true });
    }
    return error?.response?.data || { code: 500, data: error?.message || 'Network error' };
  }
}

const mappingQrisTap = {
  namespaced: true,
  state() {
    return {
      ...createListState()(),
      errors: [],
    };
  },
  mutations: {
    ...createListMutations(),

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },
  },
  actions: {
    async fetchMappingList(
      ctx,
      { date, page, itemsPerPage, search }
    ) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const limit = (itemsPerPage || 10).toString();
      const pageStr = (page || 1).toString();

      const data = JSON.stringify({
        page: pageStr,
        limit,
        search: {
          mid: search?.mid || '',
          merchant_name: search?.merchant_name || '',
          aggregator_name: search?.aggregator_name || '',
          merchant_criteria: search?.merchant_criteria || '',
          channel_provider_id: search?.channel_provider_id || '',
          channel_provider_mapping_status: search?.channel_provider_mapping_status || '',
        },
        version: generateVersionHash(pageStr + limit, date),
      });

      const urlApi = api.GET_LIST_MAPPING_QRISTAP;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code === 200) {
        ctx.commit('setTotalData', {
          payload: responseData,
        });
        ctx.commit('setData', { payload: responseData });
      }

      ctx.commit('setLoading', false);
      return responseData;
    },

    async linkMapping(ctx, { date, merchantIds, channelProviderId }) {
      const ids = (merchantIds || []).map((id) => Number(id)).filter((id) => !Number.isNaN(id));
      const cpId = Number(channelProviderId);

      const data = JSON.stringify({
        merchant_ids: ids,
        channel_provider_id: cpId,
        version: generateVersionHash(String(cpId), date),
      });

      return postRaw(ctx, api.LINK_MAPPING_QRISTAP, data);
    },

    async unlinkMapping(ctx, { date, merchantIds }) {
      const ids = (merchantIds || []).map((id) => Number(id)).filter((id) => !Number.isNaN(id));

      const data = JSON.stringify({
        merchant_ids: ids,
        version: generateVersionHash('', date),
      });

      return postRaw(ctx, api.UNLINK_MAPPING_QRISTAP, data);
    },
  },
};

export default mappingQrisTap;
